export const getMessageForRequiredFields = (inputName: string) => `${inputName} is required`;

export const getMessageForInvalidFields = (inputName: string) => `Invalid ${inputName}`;
